export const SCMPAccessTokenCookiesKey = "scmp_at";
export const SCMPAccessTokenExpireCookiesKey = "scmp_at_exp";
export const SCMPUserLoginTypeCookiesKey = "scmp_user_login_type";
export const SCMPPianoAccessTokenCookiesKey = "scmp_pat";
export const SCMPUserCookiesKey = "scmp_user";
export const RegisterEmailExpirationDateLocalStorageKey = "register_email_expiration_date";
export const JWTExpiryThreshold = 1800; // Seconds
export const JWTRefreshSWRKey = "refresh-jwt";
